import { useSettings } from '@capsicum/common';
import { FanTokenOfferingsPage } from '@capsicum/features/fan-token-offering/shared';
import { FanTokenOfferingsSection } from '@capsicum/features/fan-token-offering/web';
import { useNCWalletTokenList } from '@capsicum/features/nc-wallet/shared';
import { WalletTabContainer } from '@capsicum/features/wallet/web';
import { useNCWBalance } from '@capsicum/socios-core';
import styled from 'styled-components';

import { NCWalletChilizCard } from '../nc-wallet-chiliz-card/NCWalletChilizCard';
import { NCWalletTokenCards } from '../nc-wallet-token-cards/NCWalletTokenCards';
import { NCWalletTopMovingTokens } from '../nc-wallet-top-moving-tokens/NCWalletTopMovingTokens';
import { WCPledgeSection } from '../world-championship-pledge';

export const NCWalletTokenList = () => {
	const { areSettingsLoading, settings } = useSettings();
	const { chilizBalance, isPending: isNCWBalanceLoading, tokenBalances } = useNCWBalance();

	const {
		favouriteTeamEntry,
		isFavouriteTeamFanTokensSectionVisible,
		isLoading: isNCWWalletTokenListLoading,
		isTopMovingFanTokensSectionVisible,
		myTokenCardsEntries,
		myTokenCardsTokensShortCodes
	} = useNCWalletTokenList({ balances: tokenBalances });

	const isLoading = isNCWBalanceLoading || isNCWWalletTokenListLoading;

	return (
		<WalletTabContainer>
			<S.ListContainer>
				{settings.isFTOEnabled && !areSettingsLoading && (
					<FanTokenOfferingsSection page={FanTokenOfferingsPage.Home} />
				)}
				{settings.isWcPledgeEnabled && <WCPledgeSection />}
				<NCWalletChilizCard chilizBalance={chilizBalance} isStakeButtonDisplay />
				{isFavouriteTeamFanTokensSectionVisible && (
					<NCWalletTokenCards
						entries={favouriteTeamEntry}
						isLoading={isLoading}
						showNewsBadge
						title="ncWallet.home.myFavouriteTeamToken"
					/>
				)}
				<NCWalletTokenCards
					entries={myTokenCardsEntries}
					isLoading={isLoading}
					showNewsBadge
					title="ncWallet.home.myAssets"
				/>

				{!isLoading && isTopMovingFanTokensSectionVisible && (
					<NCWalletTopMovingTokens excludeShortCodes={myTokenCardsTokensShortCodes} />
				)}
			</S.ListContainer>
		</WalletTabContainer>
	);
};

namespace S {
	export const ListContainer = styled.article`
		width: 100%;
		display: flex;
		flex-flow: column;
		gap: ${({ theme }) => theme.spacings.large};
		margin-top: ${({ theme }) => theme.spacings.small};
	`;

	export const CardContainer = styled.div`
		width: 100%;
	`;
}
